import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { TrafficDeviationAccessService } from "../services/traffic-deviation-access.service";

export function HasTaAccessGuard(): CanActivateFn {
  return async () => {
    const router: Router = inject(Router);
    const trafficDeviationAccessService: TrafficDeviationAccessService = inject(TrafficDeviationAccessService);
    const hasAccessToTrafficDeviations = (await trafficDeviationAccessService.hasAccess()).TaWriter;
    return hasAccessToTrafficDeviations || router.createUrlTree(['/']);
  };
}